import axios from 'axios';
// eslint-disable-next-line import/no-cycle
import defaultState from './state';

import users from './api/users';
import reports from './api/reports';
import settings from './api/settings';
import projects from './api/projects';
import issues from './api/issues';
import machines from './api/machines';
import scan_options from './api/scan_options';
import connections from './api/connection';
import history from './components/Extensions/History';

function parseJSON(response) {
  if (response.status >= 200 && response.status < 300) {
    return response.request.response ? JSON.parse(response.request.response) : null;
  }
  return null;
}

function handleError(err) {
  return err.response;
}

const api = {
/**
 *  Make a request
 *
 * @param {string} url
 * @param {object} options
 * @returns Promise
 *
 */

  request: (path, options, urlAbsolute, isFile = false, handleUnAuthorized = true) => {
    const browserID = {
      'Browser-Id': localStorage.getItem('hash'),
    };

    options.headers = Object.assign(options.headers, browserID);
    let server = '';
    const baseUrl = '//'.concat(location.hostname);

    if (process.env.NODE_ENV === 'development') {
      server = baseUrl.concat(':3000') || process.env.API_HOST;
    } else {
      server = location.port !== '' ? baseUrl.concat(':', location.port) : '';
    }

    const config = {
      url: path,
      validateStatus(status) {
        if (status === 401 && handleUnAuthorized) {
          localStorage.removeItem('session');
          history.push('#/login');
        }
        return status >= 200 && status < 300;
      },
    };

    if (!urlAbsolute) {
      config.url = server + path;
    }

    Object.assign(config, options);
    return new Promise((resolve, reject) => {

      axios(config)
        .then((response) => { resolve(isFile ? response.request.response : parseJSON(response)); })
        .catch((err) => {
          const data = { ...err };
          if (data.response) {
            const code = data.response.status;
            if (code === 401) {
              localStorage.removeItem('session');
              localStorage.removeItem('main_page');
              history.push('#/login');
            }
          }
          reject(handleError(err));
        });
    });
  },

  requestHtml: (path, options) => {
    const browserID = {
      'Browser-Id': localStorage.getItem('hash'),
    };
    options.headers = Object.assign(options.headers, browserID);
    let server = '';
    const baseUrl = '//'.concat(location.hostname);

    if (process.env.NODE_ENV === 'development') {
      server = baseUrl.concat(':3000') || process.env.API_HOST;
    } else {
      server = location.port !== '' ? baseUrl.concat(':', location.port) : '';
    }

    const config = {
      url: server + path,
      ...options,
    };

    return new Promise((resolve, reject) => {
      axios(config)
        .then((response) => { resolve(response); })
        .catch((err) => {
          const data = { ...err };
          if (data.response) {
            const code = data.response.status;
            if (code === 401) {
              localStorage.removeItem('session');
              localStorage.removeItem('main_page');
              history.push('#/login');
            }
          }
          reject(handleError(err));
        });
    });
  },

  getStoragedToken: () => {
    const currentToken = localStorage.getItem('session')
      ? JSON.parse(localStorage.getItem('session')).access_token
      : '';
    const previousToken = defaultState.user.access_token;
    if (previousToken !== currentToken) {
      location.reload();
    }
    return currentToken;
  },
};

export default ({
  ...api, ...users, ...reports, ...settings, ...projects, ...issues, ...scan_options, ...machines, ...connections
});
